<template>
  <div>
    <v-skeleton-loader
      v-if="loading"
      class="mx-auto"
      type="table-heading, table-row@6, table-tfoot"
    />
    <div v-else>
      <v-tabs v-model="tab" background-color="green lighten-5" centered slider-color="yellow">
        <v-tab>Cours actuels</v-tab>
        <v-tab v-if="notStartedCourses.length">Cours à venir</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <flux-course-group :courses="activeCourses" >
            <template v-slot:header>
              <v-row>
                <v-subheader class="grey--text text--darken-4">
                  <v-btn :href="`pdf/flux`" text icon color="green" class="float-right" target="_blank">
                    <v-icon dark>mdi-file-pdf-box</v-icon>
                  </v-btn>
                </v-subheader>
              </v-row>
            </template>
          </flux-course-group>
        </v-tab-item>
        <v-tab-item v-if="notStartedCourses.length">
          <flux-course-group :courses="notStartedCourses" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>
<script>
import Course from "@/models/Course"
import FluxCourseGroup from "@/components/flux/FluxCourseGroup.vue"

export default {
  components: {
    FluxCourseGroup,
  },
  data() {
    return {
      courses: [],
      loading: true,
      edit: false,
      tab: null,
    }
  },
  mounted() {
    this.getDataFromApi()
  },
  methods: {
    async getDataFromApi() {
      // First: Load course list with student names (fast)
      const result = await Course.getCoursesOverview()
      this.courses = result.response.data.data
      this.loading = false

      // Then: Load presence rates for each course in parallel (async)
      this.loadPresenceRatesAsync()
    },
    async loadPresenceRatesAsync() {
      // Load presence rates for all active/not-started courses in parallel
      const coursesToLoad = this.courses.filter(c => c.status === 0 || c.status === 1)

      await Promise.all(
        coursesToLoad.map(async (course) => {
          try {
            const response = await Course.getCoursePresenceRates(course.id)
            const rates = response.data

            // Inject presence rates into students
            course.students.forEach((student) => {
              if (rates[student.id] !== undefined) {
                this.$set(student, "presence_rate", rates[student.id])
              }
            })
          } catch (error) {
            console.error(`Failed to load presence rates for course ${course.id}:`, error)
          }
        })
      )
    },
  },
  computed: {
    notStartedCourses: function () {
      return this.courses.filter(function (course) {
        return course.status == 0
      })
    },
    activeCourses: function () {
      return this.courses.filter(function (course) {
        return course.status == 1
      })
    },
  },
}
</script>
